const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

export const columns = [
    {
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'categoryName',
        text: 'Category',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'description',
        text: 'Description',
        sort: true,
        headerStyle: headerStyle,
        style: () => ({ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' })
    }
];

export const sorting = [{
    dataField: 'createdOn',
    order: 'desc'
}];